import { useHistory } from 'react-router-dom';
import { Button } from '../../../components/items/Button';
import { Container } from './join';
import { CheckIcon } from '../../../components/icon/icon';
import styled from 'styled-components';

const JoinComplate = () => {
  const history = useHistory();
  const goLogin = () => {
    history.push('/');
  };

  return (
    <NewContainer>
      <ComplateViewBox className="complate-view-box">
        <div className="icon-box">
          <CheckIcon />
        </div>
        <p>회원가입이 완료되었습니다.</p>
        <span>관리자의 가입 승인 후 로그인 하시기 바랍니다.</span>
      </ComplateViewBox>
      <Button title="로그인 화면으로 이동" onClick={goLogin} fiexd />
    </NewContainer>
  );
};

export default JoinComplate;

//styled
const NewContainer = styled(Container)`
  height: 100%;
`;

const ComplateViewBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon-box {
    display: flex;
    margin-bottom: 2.4rem;
  }
  p {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.8rem;
  }
  span {
    display: flex;
    font-size: 1.4rem;
    color: ${(props) => props.theme.textAAAColor};
  }
`;
